"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFacetecRefFromFirebase = getFacetecRefFromFirebase;
exports.syncFacetecRefFromFirebase = syncFacetecRefFromFirebase;
exports.clearFacetecReferences = clearFacetecReferences;
exports.handleEnrollmentNotFound = handleEnrollmentNotFound;
var firestore_1 = require("firebase/firestore");
var auth_1 = require("../../../features/slices/auth");
var user_profile_1 = require("../../../features/slices/user-profile");
var store_1 = require("../../../store");
var firebase_1 = require("../../../utils/firebase");
var user_state_1 = require("../../../utils/user-state");
/**
 * Fetches the facetecDBRef directly from Firebase Firestore
 * This is the source of truth for the enrollment reference
 */
function getFacetecRefFromFirebase() {
    return __awaiter(this, void 0, void 0, function () {
        var userState, userDocRef, userDocSnapshot, userData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    userState = (0, user_state_1.getCurrentUserState)();
                    if (!(userState === null || userState === void 0 ? void 0 : userState.uid)) {
                        console.warn("No user UID available to fetch Firebase reference");
                        return [2 /*return*/, null];
                    }
                    userDocRef = (0, firestore_1.doc)(firebase_1.firestore, "users", userState.uid);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(userDocRef)];
                case 1:
                    userDocSnapshot = _a.sent();
                    if (userDocSnapshot.exists()) {
                        userData = userDocSnapshot.data();
                        return [2 /*return*/, (userData === null || userData === void 0 ? void 0 : userData.facetecDBRef) || null];
                    }
                    return [2 /*return*/, null];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching FaceTec reference from Firebase:", error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * Updates the facetecDBRef in MongoDB via backend API
 */
function updateFacetecInMongoDB(facetecDBRef) {
    return __awaiter(this, void 0, void 0, function () {
        var state, accessToken, apiUrl, response, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    state = store_1.store.getState();
                    accessToken = state.auth.access_token;
                    if (!accessToken) {
                        console.warn("No access token available for MongoDB update");
                        return [2 /*return*/, false];
                    }
                    apiUrl = process.env.API_URL || "http://localhost:7002";
                    return [4 /*yield*/, fetch("".concat(apiUrl, "/v1/user/update-profile"), {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify({ facetecDBRef: facetecDBRef }),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data.success === true];
                case 3:
                    error_2 = _a.sent();
                    console.error("Error updating FaceTec reference in MongoDB:", error_2);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * Syncs the Firebase facetecDBRef to Redux state and MongoDB
 * Returns the synced reference if successful, null if not
 */
function syncFacetecRefFromFirebase() {
    return __awaiter(this, void 0, void 0, function () {
        var firebaseRef, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getFacetecRefFromFirebase()];
                case 1:
                    firebaseRef = _a.sent();
                    if (!firebaseRef) {
                        console.log("No FaceTec reference found in Firebase");
                        return [2 /*return*/, null];
                    }
                    // Update Redux state (both auth and profile)
                    store_1.store.dispatch((0, auth_1.setFacetecDBRef)(firebaseRef));
                    store_1.store.dispatch((0, user_profile_1.setProfileFacetecDBRef)(firebaseRef));
                    // Update MongoDB (fire and forget)
                    updateFacetecInMongoDB(firebaseRef).then(function (success) {
                        if (success) {
                            console.log("✅ FaceTec reference synced to MongoDB from Firebase");
                        }
                        else {
                            console.warn("⚠️ Failed to sync FaceTec reference to MongoDB");
                        }
                    });
                    console.log("✅ FaceTec reference synced from Firebase:", firebaseRef);
                    return [2 /*return*/, firebaseRef];
                case 2:
                    error_3 = _a.sent();
                    console.error("Error syncing FaceTec reference from Firebase:", error_3);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * Clears the facetecDBRef from both Firebase and MongoDB
 * Used when enrollment reference is invalid and needs re-enrollment
 */
function clearFacetecReferences() {
    return __awaiter(this, void 0, void 0, function () {
        var userState, userDocRef, state, accessToken, apiUrl, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    userState = (0, user_state_1.getCurrentUserState)();
                    if (!(userState === null || userState === void 0 ? void 0 : userState.uid)) {
                        console.warn("No user UID available to clear references");
                        return [2 /*return*/, false];
                    }
                    userDocRef = (0, firestore_1.doc)(firebase_1.firestore, "users", userState.uid);
                    return [4 /*yield*/, (0, firestore_1.updateDoc)(userDocRef, {
                            facetecDBRef: (0, firestore_1.deleteField)(),
                        })];
                case 1:
                    _a.sent();
                    console.log("✅ Cleared FaceTec reference from Firebase");
                    // Clear from Redux state (both auth and profile)
                    store_1.store.dispatch((0, auth_1.setFacetecDBRef)(undefined));
                    store_1.store.dispatch((0, user_profile_1.setProfileFacetecDBRef)(undefined));
                    state = store_1.store.getState();
                    accessToken = state.auth.access_token;
                    if (!accessToken) return [3 /*break*/, 3];
                    apiUrl = process.env.API_URL || "http://localhost:7002";
                    return [4 /*yield*/, fetch("".concat(apiUrl, "/v1/user/update-profile"), {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify({ facetecDBRef: "" }),
                        })];
                case 2:
                    _a.sent();
                    console.log("✅ Cleared FaceTec reference from MongoDB");
                    _a.label = 3;
                case 3: return [2 /*return*/, true];
                case 4:
                    error_4 = _a.sent();
                    console.error("Error clearing FaceTec references:", error_4);
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * Handles FaceTec authentication failure due to "enrollment does not exist"
 *
 * Flow:
 * 1. Check Firebase for facetecDBRef
 * 2. If Firebase has different ref than what was used, sync it and return for retry
 * 3. If Firebase has same ref or no ref, clear all refs and signal re-enrollment needed
 *
 * @param usedReference - The reference that was used in the failed authentication
 * @returns Object with action to take: 'retry' with new ref, or 'enroll' if re-enrollment needed
 */
function handleEnrollmentNotFound(usedReference) {
    return __awaiter(this, void 0, void 0, function () {
        var firebaseRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("🔍 Handling enrollment not found for reference:", usedReference);
                    return [4 /*yield*/, getFacetecRefFromFirebase()];
                case 1:
                    firebaseRef = _a.sent();
                    console.log("🔍 Firebase reference:", firebaseRef);
                    // Step 2: Compare references
                    if (firebaseRef && firebaseRef !== usedReference) {
                        // Firebase has a different reference - sync and retry
                        console.log("🔄 Firebase has different reference, syncing...");
                        // Update Redux (both auth and profile) and MongoDB with Firebase reference
                        store_1.store.dispatch((0, auth_1.setFacetecDBRef)(firebaseRef));
                        store_1.store.dispatch((0, user_profile_1.setProfileFacetecDBRef)(firebaseRef));
                        // Update MongoDB in background
                        updateFacetecInMongoDB(firebaseRef);
                        return [2 /*return*/, { action: "retry", newReference: firebaseRef }];
                    }
                    // Step 3: References match or no Firebase ref - clear and re-enroll
                    console.log("🗑️ Clearing invalid references, re-enrollment required");
                    return [4 /*yield*/, clearFacetecReferences()];
                case 2:
                    _a.sent();
                    return [2 /*return*/, { action: "enroll" }];
            }
        });
    });
}
